<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>修改用户</BreadcrumbItem>
        </Breadcrumb>
        <div class="dev_data">
          <div><span class="line_name"><b style="color: red;">*</b>用户名</span><Input v-model="userForm.userName" style="width: 300px" :maxlength=32 /></div>
          <!--<div><span class="line_name"><b style="color: red;">*</b>密码</span><Input v-model="userForm.password" type="password" style="width: 300px" :maxlength=32 /></div>-->
          <div><span class="line_name"><b style="color: red;">*</b>所属公司</span><Input v-model="userForm.company" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name"><b style="color: red;">*</b>关联角色</span>
            <Select v-model="userForm.roleId" style="width:300px;text-align: left;">
              <Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
          <div><span class="line_name">联系电话</span><Input v-model="userForm.phone" style="width: 300px" :maxlength=11 /></div>
          <div><span class="line_name">地址</span><Input v-model="userForm.addr" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name">备注</span><Input v-model="userForm.memo" style="width: 300px" :maxlength=32 /></div>
          <div class="btn">
            <Button type="primary" style="width: 120px;" @click="submit">确定</Button>
            <Button style="width: 120px;" @click="goBackPage">取消</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {nSuccess, nError} from '../../util/notice'
import {errorHandler} from '../../util/errorHandler'
import {pattern} from '../../util/regular'

export default {
  components: {TopOpe},
  name: 'modify-account',
  data () {
    return {
      userForm: {
        userName: '',
        company: '',
        roleId: '',
        phone: '',
        addr: '',
        memo: ''
      },
      roleList: []
    }
  },
  created () {
    this.getRoleList()
  },
  methods: {
    goBackPage () {
      this.$router.push({
        path: '/account_management'
      })
    },
    getRoleList () {
      this.$axios.post(`${httpUrl.url}/manage/authority/getList`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.roleList = res.data.data
            let searchId = this.$route.params.id
            this.getUser(searchId)
          }
        })
        .catch(errorHandler('查询失败'))
    },
    getUser (id) {
      this.$axios.get(`${httpUrl.url}/manage/user/getById/${id}`)
        .then(res => {
          if (res.data.retCode === 1) {
            this.userForm = res.data.data
            console.log(this.roleList)
          }
        })
        .catch(errorHandler('查询失败'))
    },
    submit () {
      let phoneTest = pattern.phone.test(this.userForm.contactPhone)
      if (!this.userForm.userName) {
        nError('用户不能为空')
        return false
      }
      if (!this.userForm.company) {
        nError('所属公司不能为空')
        return false
      }
      if (!this.userForm.roleId) {
        nError('请选择关联角色')
        return false
      }
      if (this.phone && !phoneTest) {
        nError('请输入正确的手机号')
        return false
      }
      this.userForm.id = parseInt(this.$route.params.id)
      this.$axios.post(`${httpUrl.url}/manage/user/update`, this.userForm)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.$router.push({
              path: '/account_management'
            })
          }
        })
        .catch(errorHandler('修改失败'))
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    width: 100%;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }
  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .dev_data {
    margin-top: 80px;
  }

  .dev_data div {
    margin: 10px;
    text-align: center;
  }

  .btn button {
    margin: 30px 20px 0;
  }
  .line_name {
    display: inline-block;
    width: 60px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/modify-account.vue